module.exports = __webpack_public_path__ + "7f85ba896ab941e7436445b3cdc3289d.svg";